module.exports = __webpack_public_path__ + "media/assets/images/category/Love@2x-113a6d559e3b8e3263289616a6123209.png";